export default __webpack_public_path__ + "static/media/tailwind-css.50fbcf51.svg";